import { updateDoc, doc, getDoc, getDocs, collection } from "@firebase/firestore";
import { hideLoading, setItemCategoriesList, setItemStatusList, setItemTypesList, showLoading } from "./items-edit-slice";
import { editItems } from "../items-list/items-list-slice";
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { showItemInformationDialog } from "../items-list/items-list-details/item-tabs/item-information/item-information-list/item-information-list-slice";

// export const getItemsDataService = async (dispatch, db, coll, id) => {
//     try {
//         const docRef = doc(db, coll, id);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//             return docSnap.data();
//         } else {
//             dispatch(showWarningSnackbar("This document no longer exists."));
//         }
//     } catch(e) {
//         console.error("ItemsEdit getItemsDataService error: ", e);
//     }
// };

const calculateSalePrice = async (dispatch, original_price, increase) => {
    try {
        if (original_price > 0 && increase > 0) {
            const increaseAmount = original_price * (increase / 100);
            const sellingPrice = parseFloat(original_price) + increaseAmount;
            const sellingPriceRounded = Math.round(sellingPrice);
            return sellingPriceRounded;
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when calculating selling price.'))
        console.error("ItemsEdit calculateSalePrice error: ", e);
    }
};

const calculateRentPrice = async (dispatch, original_price, rent_percent) => {
    try {
        if (original_price > 0 && rent_percent > 0) {
            const increaseAmount = original_price * (rent_percent / 100);
            const rentingPriceRounded = Math.round(increaseAmount);
            return rentingPriceRounded;
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when calculating rental price.'))
        console.error("ItemsEdit calculateRentPrice error: ", e);
    }
};

const calculateDepositPrice = async (dispatch, original_price, deposit_percent) => {
    try {
        if (original_price > 0 && deposit_percent > 0) {
            const increaseAmount = original_price * (deposit_percent / 100);
            const depositPriceRounded = Math.round(increaseAmount);
            return depositPriceRounded;
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when calculating deposit price.'))
        console.error("ItemsEdit calculateDepositPrice error: ", e);
    }
};

export const editItemsService = async (dispatch, db, coll, id, formData) => {
    dispatch(showLoading());
    try {
        if (formData.type === "For sale") {
            const calculatedUnitPrice = await calculateSalePrice(dispatch, formData.original_price, formData.increase);
            const new_data = {
                ...formData,
                unit_price: calculatedUnitPrice,
            };
            await updateDoc(doc(db, coll, id), new_data);
            // Wait for the document to be updated
            await new Promise(resolve => setTimeout(resolve, 1000));
            const docSnap = await getDoc(doc(db, coll, id));
            const updatedData = docSnap.data();
            const data = {
                ...updatedData,
                id: id,
            };
            dispatch(showItemInformationDialog(docSnap.data()));
            dispatch(editItems(data));
        } else {
            const calculatedRentPrice = await calculateRentPrice(dispatch, formData.original_price, formData.rent_percent);
            const calculatedDepositPrice = await calculateDepositPrice(dispatch, formData.original_price, formData.deposit_percent);
            const new_data = {
                ...formData,
                rent_price: calculatedRentPrice,
                deposit: calculatedDepositPrice
            };
            await updateDoc(doc(db, coll, id), new_data);
            // Wait for the document to be updated
            await new Promise(resolve => setTimeout(resolve, 1000));
            const docSnap = await getDoc(doc(db, coll, id));
            const updatedData = docSnap.data();
            const data = {
                ...updatedData,
                id: id,
            };
            dispatch(showItemInformationDialog(docSnap.data()));
            dispatch(editItems(data));
        }
        dispatch(showSuccessSnackbar('Updated successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Update failed! Please, try again.'));
        console.error("ItemsEdit editItemsService error: ", e);
    }
    dispatch(hideLoading());
};

export const getItemTypesListService = async (dispatch, db, coll) => {
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemTypesList(data));
        });
    } catch(e) {
        console.error("ItemsEdit getItemTypesService error: ", e);
    }
};

export const getItemStatusListService = async (dispatch, db, coll) => {
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemStatusList(data));
        });
    } catch(e) {
        console.error("ItemsEdit getItemStatusListService error: ", e);
    }
};

export const getItemCategoriesListService = async (dispatch, db, coll) => {
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemCategoriesList(data));
        });
    } catch(e) {
        console.error("ItemsEdit getItemCategoriesListService error: ", e);
    }
};
